import script from "./pay-info-confirm.vue?vue&type=script&lang=tsx&setup=true"
export * from "./pay-info-confirm.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__